export function addAbsolutePathPrefix(route: string): string {
  return `/${route}`;
}
